export const drawerContentStyles = {
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
};

export const progressHeaderStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '14px',
  padding: '16px 20px',
  borderBottom: ({ palette }) => `1px solid ${palette.divider}`,
  background: ({ palette }) =>
    `linear-gradient(180deg, ${palette.primary.soft ?? palette.primary.light}22, ${
      palette.background.paper
    })`,
};

export const progressHeaderIconStyles = {
  width: '38px',
  height: '38px',
  borderRadius: '10px',
  backgroundColor: ({ palette }) =>
    palette.mode === 'dark' ? palette.primary.dark : palette.primary.main,
  color: ({ palette }) => palette.common.white,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
};

export const progressHeaderInfoStyles = {
  minWidth: 0,
  display: 'flex',
  flexDirection: 'column',
};

export const progressScrollAreaStyles = {
  flex: 1,
  overflowY: 'auto',
  minHeight: 0,
};

export const waitingMessageStyles = {
  padding: '20px',
};

export const segmentRowStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  padding: '10px 20px',
  borderBottom: ({ palette }) => `1px solid ${palette.divider}`,
};

export const segmentInfoStyles = {
  flex: 1,
  minWidth: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: '2px',
};

export const segmentNameStyles = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

export const getStatusBadgeStyles = status => {
  const baseStyles = {
    display: 'inline-flex',
    alignItems: 'center',
    borderRadius: '12px',
    padding: '2px 8px',
    flexShrink: 0,
  };

  const statusLower = (status ?? '').toLowerCase();

  if (statusLower === 'classified') {
    return {
      ...baseStyles,
      backgroundColor: ({ palette }) =>
        palette.mode === 'dark' ? palette.success.soft : `${palette.success.light}66`,
      color: ({ palette }) =>
        palette.mode === 'dark' ? palette.success.light : palette.success.dark,
    };
  }

  if (statusLower === 'failed') {
    return {
      ...baseStyles,
      backgroundColor: ({ palette }) =>
        palette.mode === 'dark' ? palette.error.soft : `${palette.error.light}44`,
      color: ({ palette }) => (palette.mode === 'dark' ? palette.error.light : palette.error.dark),
    };
  }

  if (statusLower === 'unrecognized') {
    return {
      ...baseStyles,
      backgroundColor: ({ palette }) =>
        palette.mode === 'dark' ? palette.warning.soft : `${palette.warning.light}55`,
      color: ({ palette }) =>
        palette.mode === 'dark' ? palette.warning.light : palette.warning.dark,
    };
  }

  if (statusLower === 'classifying') {
    return {
      ...baseStyles,
      backgroundColor: ({ palette }) =>
        palette.mode === 'dark' ? palette.primary.soft : `${palette.primary.light}33`,
      color: ({ palette }) =>
        palette.mode === 'dark' ? palette.primary.light : palette.primary.dark,
    };
  }

  // pending / unknown
  return {
    ...baseStyles,
    backgroundColor: ({ palette }) => palette.background.secondary,
    color: ({ palette }) => palette.text.secondary,
  };
};

export const reviewAffordanceStyles = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '12px',
  flex: 1,
  padding: '32px 20px',
};
